




















































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { masterCodeModule } from '../store/modules/MasterCode'; // ストアモジュール
import { IMCT, IMC } from '../store/dto/MasterCode'; // dto
import { KanriConstants } from '../fixed/KanriConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class MasterCodeTableSearch extends ApiAccessBase {

  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [{}];
  // 画面初期化処理
  // component生成時に実行
  private created() {
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['masterCodeTable_search']); //検索条件

    const path: string = KanriConstants.CODE_PATH + '/init';
    // TODO 登録画面から戻った際の再検索
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //検索結果.ボタンの設定
        this.headers.shift(); //先頭の空白列削除
        this.headers.push(
        {text: '編集',
          align: 'center',
          sortable: false,
          value: 'edit',
          width: 90,
        },
        {
          text: '削除',
          align: 'center',
          sortable: false,
          value: 'delete',
          width: 90,
        },
        {
          text: '複写',
          align: 'center',
          sortable: false,
          value: 'repeat',
          width: 90,
        });
        //検索結果.DBから展開
        for (const item of this.variablecols['masterCodeTable_searchResult'] ) {
          this.headers.push({text: item.label,
                            align: item.align,
                            sortable: item.sortable,
                            value: item.name,
                            width: item.width,
                            } );
        }
      }
    });
  }

  /**
   * コード表登録画面への遷移
   * (新規追加ボタン押下時に発火)
   */
  private moveInfo() {
    router.push({ name: 'masterCodeTableInfo' });
  }

  /**
   * コード表の削除
   * (表削除列_削除アイコン押下時に発火)
   */
  private deleteCodeTable(param: IMCT) {
    if (window.confirm(Message.I0001)) {
      masterCodeModule.setCodeTable(param);
      // APIアクセス
      this.apiAccess(
        KanriConstants.CODE_PATH + masterCodeModule.GET_PATH
           , Constants.API_METHOD_POST, false, false)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 成功
          alert(Message.I0002);
          this.searchCodeTable(); //再検索
        } else {
          // 失敗
          alert(Message.E0000);
        }
      });
    }
  }

  /**
   * コード表の編集
   * (編集列_編集アイコン押下時に発火)
   */
  private dataTransferInfo(param: IMCT) {
    masterCodeModule.setCodeTable(param);
    masterCodeModule.transferToInfo();
    router.push({ name: 'masterCodeTableInfo' });
  }

  /**
   * コードの編集(コード一覧画面への遷移)
   * (コード表番号列_編集アイコン押下時に発火)
   */
  private dataTransferInfo2(param: IMCT) {
    masterCodeModule.setCodeTable(param);
    masterCodeModule.transferToInfo();
    router.push({ name: 'masterCodeSearch' });
  }

  /**
   * コード表の検索
   * (検索ボタン押下時に発火)
   */
  private searchCodeTable() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // ＜関連チェックをいれるならここ＞
    this.apiAccess(KanriConstants.CODETABLENO_OB_CODENO_PATH, Constants.API_METHOD_POST, true, true);
    // 検索一覧へジャンプ
    this.hrefElement('searchResults', -130);
  }
}
